/*global _url*/
let url = new URL('/', _url.corporate)
let isCorporate = window.location.hostname == url.hostname;
import { isLogin } from '@/router/_auth';

export default [
	{
		path: '/login',
		name: 'login',
		redirect: { name: `${isCorporate ? 'corporateLogin' : 'individualLogin'}` },
		component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue'),
		children: [
			{
				path: 'individual',
				name: 'individualLogin',
				meta: {
					title: 'Bireysel Şube',
					layout: 'login'
				},
				beforeEnter: async (to, from, next) => {
					let status = isLogin();
					if (status) {
						next({
							name: "individual"
						})
					} else next();
					return;
				},
				component: () => import(/* webpackChunkName: "login" */ '../views/login/Individual.vue')
			},
			{
				path: 'corporate',
				name: 'corporateLogin',
				meta: {
					title: 'Kurumsal Şube',
					layout: 'login'
				},
				beforeEnter: async (to, from, next) => {
					let status = isLogin();
					if (status) {
						next({
							name: "corporateHome"
						})
					} else next();
					return;
				},
				component: () => import(/* webpackChunkName: "login" */ '../views/login/Corporate.vue'),
			}
		]
	},
	{
		path: '/login/individual/sms',
		name: 'individualSms',
		meta: {
			title: 'Bireysel Şube SMS Doğrulama',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/individual/Sms.vue')
	},
	{
		path: '/login/corporate/sms',
		name: 'corporateSms',
		meta: {
			title: 'Kurumsal Şube SMS Doğrulama',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/corporate/Sms.vue')
	},
	{
		path: '/login/corporate/oks',
		name: 'oks',
		meta: {
			title: 'Kurumsal Şube OKS Teklif Al',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/corporate/oks/Home.vue')
	},
	{
		path: '/login/corporate/oks/pdf',
		name: 'pdf',
		meta: {
			title: 'Kurumsal Şube OKS Teklif Al',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/corporate/oks/Pdf.vue')
	},
	{
		path: '/login/individual/signup',
		name: 'individualSignup',
		meta: {
			title: 'Bireysel Şube Yeni Üye',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/individual/signup/Home.vue')
	},
	{
		path: '/login/individual/signup/kvkk',
		name: 'loginKvkk',
		meta: {
			title: 'Yeni Üye KVKK',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/individual/signup/Kvkk.vue')
	},
	{
		path: '/login/individual/signup/trade',
		name: 'loginTrade',
		meta: {
			title: 'Yeni Üye Ticari Elektronik İleti Kapsamı',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/individual/signup/Trade.vue')
	},
	{
		path: '/login/individual/signup/service',
		name: 'loginService',
		meta: {
			title: 'Yeni Üye Hizmet Sözleşmesi',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/individual/signup/Service.vue')
	},
	{
		path: '/login/individual/forget',
		name: 'individualForget',
		meta: {
			title: 'Bireysel Şube Şifremi Unuttum',
			layout: 'noauth'
		},
		component: () => import(/* webpackChunkName: "login" */ '../views/login/individual/forget/Home.vue')
	}
]